export default __webpack_public_path__ + "static/media/cat6a.13741e2b.jpg";